



















































































  import GuardileoBox from '@/components/GuardileoBox.vue';
  import GuardileoCheckbox from '@/Drittlandtransferpruefung/GuardileoCheckbox.vue';
  import { GuardileoVueComponent } from '@/lib';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  export interface Option {
      id: string;        
      text: string;
      color?: string;
      icon: string;
      badge?: string;
      keywords: string;
      inner_options?: Option[];
      ist_aktiv: boolean; 
  }


  @Component({
components: { GuardileoBox, GuardileoCheckbox },})
  export default class extends GuardileoVueComponent {    
      private form_visible: boolean = false;
      @Prop({default: false}) private hideOptionsWithoutSelectedInnerOptions!: boolean;

      @Prop() private actiontitle!: string;
      @Prop() private options!: Option[];
      @Prop({default: null}) private selectionOptions!: Option[] | null;

      @Prop() private selection!: Record<string, true>;
      @Prop() private disabled!: boolean;
      @Prop({default: false}) private keepChildrenOnSearch!: boolean;

      get internalOptions() {
          if(!this.hideOptionsWithoutSelectedInnerOptions) return this.options;
          return this.options.filter(c => {
              const hasInnerOptions = c.inner_options && c.inner_options.length > 0;
              if(hasInnerOptions) {
                  const atleastOneSelected = c.inner_options!.some(c => this.is_selected(c.id));
                  return hasInnerOptions && atleastOneSelected;
              } else return true;
              
          } )
      }

      private form_selection: Record<string, true> = {};
      private form_collapsed: Record<string, true> = {};

      private filter: string = "";

      mounted() {
          this.form_selection = {...this.selection};
      }

      show_form() {
          this.form_visible = true;
      }

      hide_form() {
          this.form_visible = false;
      }

      is_form_selected(id: string) {
          return this.form_selection[id];
      }

      is_selected(id: string) {
          return this.selection[id];
      }

      toggle(id: string) {
          if (this.form_selection[id]) {
              delete this.form_selection[id];
              for (const option of this.options) {
                  if (option.id == id && option.inner_options) {
                      for (const inner of option.inner_options) {
                          if (this.is_form_selected(inner.id)) this.toggle(inner.id);
                      }
                  }
              }
          } else {
              this.form_selection[id] = true;
          }
          this.form_selection = {...this.form_selection};
          this.$forceUpdate();
      }

      is_collapsed(id: string) {
          return false;
      }

      commit() {
          const added = [];
          const removed = [];
          for (const option of this.options) {
              if (!this.selection[option.id]) added.push(option.id);
              if (!this.form_selection[option.id]) removed.push(option.id);
              if (option.inner_options) {
                  for (const inner of option.inner_options) {
                      if (!this.selection[inner.id]) added.push(inner.id);
                      if (!this.form_selection[inner.id]) removed.push(inner.id);
                  }                    
              }
          }
          this.$emit('input', {added, removed});
          this.filter = "";
          this.hide_form();
      }

      revert() {
          this.form_selection = {...this.selection};
          this.$forceUpdate();
          this.filter = "";
          this.hide_form();
      }

      filtered(options: Option[]): Option[] {
          options = options.filter(_=> _.ist_aktiv || this.is_selected(_.id));
          if (!this.filter || this.filter == "") return options;
          const f = this.filter.toLowerCase();
          return options.filter(_ => _.keywords.toLowerCase().indexOf(f) != -1);
      }
      getColor(option: Option){
          return option.color === undefined ? 'status-class-7' : option.color;  
      }
  }
